export const RIGHTS_SUCCESS = 'RIGHTS_SUCCESS';
export const RIGHTS_FAILURE = 'RIGHTS_FAILURE';
export const RIGHTS_REQUEST = 'RIGHTS_REQUEST';
export const INITIALIZE_RIGHTS = 'INITIALIZE_RIGHTS';
export const STATUS_UPDATE = 'STATUS_UPDATE';
